<section class="show" #steeldart>
  <h3><span>Steeldart spielen</span><br>in Lohfelden bei Kassel</h3>

  <p>
    Ab sofort könnt ihr bei uns im Dart Rock Café auch <strong>Steeldart</strong> spielen!
    Ob alleine oder mit Freunden – unsere Boards stehen für euch bereit.
    Bitte meldet euch vorab telefonisch oder per E-Mail an.
    Slots sind nur nach Bestätigung verfügbar.
  </p>

  <ul class="usp">
    <li>🎯 Hochwertige Steeldart-Scheiben</li>
    <li>👥 Platz für Einzelspieler & Gruppen</li>
    <li>📅 Voranmeldung für garantierten Slot</li>
    <li>🍺 Spielen in gemütlicher Kneipen-Atmosphäre</li>
  </ul>
  <p class="rang">
    Schaut auch mal bei unserer <a [routerLink]="['rangliste-2026']">Steeldart Rangliste</a> vorbei!
  </p>
  <p class="links">
    📞 Telefon: <a href="tel:0561515643">0561 515643</a><br>
    📧 E-Mail: <a href="mailto:mail@dart-rock-cafe.de">mail@dart-rock-cafe.de</a>
  </p>
</section>
